import { render, staticRenderFns } from "./MModalButton.vue?vue&type=template&id=5b284c07&scoped=true&lang=pug&"
import script from "./MModalButton.vue?vue&type=script&lang=ts&"
export * from "./MModalButton.vue?vue&type=script&lang=ts&"
import style0 from "./MModalButton.vue?vue&type=style&index=0&id=5b284c07&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b284c07",
  null
  
)

export default component.exports